module.exports = __webpack_public_path__ + "static/media/Facebook.08f9460b.svg";